module.exports = __webpack_public_path__ + "assets/img/new-icon.19ae2eb9.png";